import { put, call } from 'redux-saga/effects';
import { createQadraSaga } from './shared';
import { ADDRESSES_GET } from '../actions/types';
import { apiUserAddressesGet } from '../api/user';

function* addressesGet({ payload: { userId } }) {
  const { addresses } = yield call(apiUserAddressesGet, userId);
  yield put({
    type: ADDRESSES_GET._SUCCESS,
    payload: { addresses, userId },
  });
}

const watchAddressesGet = createQadraSaga(addressesGet, {
  action: ADDRESSES_GET._REQUEST,
});

export default [watchAddressesGet];
